import Regimens from '../../../../components/Regimens'
import { MedicationRegimensProps } from '../utils/types'

export const MedicationRegimens = ({ lists }: MedicationRegimensProps) => {
  return (
    <Regimens
      recordLabel='Medication'
      amountEnabled
      frequencyEnabled
      methodEnabled
      lists={lists}
      alert='Please include ALL medications that you are taking, even if they are not for ALS.'
    />
  )
}
